import React from "react";
import Layout from "../../components/Layout/Layout";
import Feedback from "../../components/general/Feedback/Feedback";
import History from "../../components/pages/AboutUs/History/History";

const AboutUsPage: React.FC = () => {
  return (
    <Layout>
      <History />
      <Feedback />
    </Layout>
  );
};

export default AboutUsPage;
